import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-204" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-205" data-mp="yto8on8960iw">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-206" data-mp="kx13xya2662f">
          <span aria-hidden="true" data-id="element-207" data-mp="ptho6he500a8">📦 </span>What&apos;s Inside the Math Ready
          Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="b54yu39k1fop">
          {packItems.map(item => <li key={item.title} className="rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-209" data-mp="fyzix7t2nwob">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-210" data-mp="74bd9gjl4cyz">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-211" data-mp="3odzpydx284jj">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-212" data-mp="3tb9l8a74rafa">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}